import React from 'react';
import { Button } from 'components/components/atoms';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import cx from 'classnames';

const StyledButton = styled(Button)`
  ${({ smallCTA }) =>
    smallCTA &&
    `
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 3rem;
    padding-right: 3rem;
    height: 3.125rem;
  `}
`;

const ButtonCTA = ({
  fields,
  color = 'action-blue',
  textColor = 'action-blue',
  className,
  smallCTA,
  hoverState,
}) => {
  const cta = getFieldValue(fields, 'buttonCta') || {};
  const btnColor = color || fields.color;

  return (
    <StyledButton
      color={btnColor}
      textColor={textColor}
      href={cta.href}
      smallCTA={smallCTA}
      className={cx(
        {
          'hover:bg-mattamy-blue-dark': hoverState && color === 'action-blue',
        },
        className,
      )}
    >
      {cta.text}
    </StyledButton>
  );
};

export default ButtonCTA;
